import styled from "styled-components";

export const NewsArticleDate = styled.p`
    color: ${props => props.theme.theme_vars.colours.grey_darkest};
    margin-top: 15px;
    margin-bottom: 20px !important;
`
